import React from 'react';

function initialsFromLabel(label) {
  if (!label || typeof label !== 'string') return '?';
  const parts = label.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return label.slice(0, 2).toUpperCase();
}

/**
 * @param {string} [photoUrl]
 * @param {string} label — used for alt text and initials fallback
 * @param {number} [size]
 * @param {string} [className]
 */
export default function UserAvatar({ photoUrl, label = '', size = 40, className = '' }) {
  const initials = initialsFromLabel(label);
  const px = `${size}px`;
  const style = {
    width: px,
    height: px,
    minWidth: px,
    borderRadius: '50%',
    overflow: 'hidden',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--bg-tertiary)',
    border: '1px solid var(--border-color)',
    fontSize: `${Math.max(11, Math.round(size * 0.36))}px`,
    fontWeight: 600,
    color: 'var(--logo-cyan-teal)'
  };

  if (photoUrl) {
    return (
      <span className={className} style={style} title={label}>
        <img src={photoUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      </span>
    );
  }

  return (
    <span className={className} style={style} title={label} aria-hidden={!label}>
      {initials}
    </span>
  );
}
